<template>
    <div v-loading="loading" class="app-zone-container load-moudle">
        <template v-if="!loading">
            <div class="page-head">
                <header
                    :style="{
                        color: $root.officialNormalFontColor,
                        backgroundColor: $root.officialBackgroundColor,
                    }"
                >
                    <img
                        :src="backIcon" class="back-icon"
                        @click="goBackClick"
                    >
                    <div class="title">{{ appDetail.appName }}</div>
                    <img
                        v-if="userInfo.is_login && !isSem" class="is-login"
                        :src="userInfo.avatar" alt=""
                        @click="toOrderPage"
                    >
                    <div
                        v-else-if="!isSem" class="not-login"
                        @click="loginClick"
                    >登录</div>
                </header>
                <tab
                    :tabs="tabs"
                    @onTabChange="onTabChange"
                />
            </div>
            <section v-if="tabs[$root.tabIndex] === '详情'">
                <detail
                    :app-detail="appDetail"
                    :app-name="appDetail.appName"
                    :app-type="appDetail.appType"
                    :load-more-components="loadMoreComponents"
                    :score-data="scoreData"
                    :is-sem="isSem === 1"
                    :is-login="userInfo.is_login"
                    :is-new-card="isNewCard"
                    :tieba-info="tiebaInfo"
                    @givepriceTrendData="givepriceTrendData"
                />
            </section>
            <section v-if="tabs[$root.tabIndex] === '动态'">
                <offical
                    :app-detail="appDetail"
                    :app-name="appDetail.appName"
                    :app-type="appDetail.appType"
                />
            </section>
            <section v-if="tabs[$root.tabIndex] === '评价'">
                <comment
                    :app-praise="appDetail.mark"
                    :app-comment="appComment"
                    :app-name="appDetail.appName"
                    :app-type="appDetail.appType"
                    :is-sem="isSem"
                    :score-data="scoreData"
                    @questionClick="toggleComFoldPage"
                />
            </section>
            <section v-if="tabs[$root.tabIndex] === '问答'">
                <answer
                    :package-type="packageType"
                    :app-praise="appDetail.mark"
                    :app-comment="appComment"
                    :app-name="appDetail.appName"
                    :app-type="appDetail.appType"
                    :is-sem="isSem"
                    :bg-color="appDetail.official_big_img_color.button"
                />
            </section>
            <section v-if="tabs[$root.tabIndex] === '视频'" class="app-video">
                <app-video
                    :app-name="appDetail.appName"
                    :app-type="appDetail.appType"
                    :app-id="appDetail.appId"
                />
            </section>
            <section v-if="tabs[$root.tabIndex] === '贴吧'" class="tieba-wrapper">
                <tieba
                    :app-tieba="appTieba"
                    :app-name="appDetail.appName"
                    :app-type="appDetail.appType"
                />
            </section>

            <section v-if="tabs[$root.tabIndex] === '攻略'">
                <strategy
                    :app-id="appDetail.appId"
                    :strategy-tab-list="appDetail.strategy_tag"
                    :package-type="packageType"
                    :app-type="appDetail.appType"
                    @showStrategyCatePannel="showStrategyCatePanel = true"
                />
            </section>

            <section v-if="tabs[$root.tabIndex] === '资讯'" class="news-wrapper">
                <news-item
                    v-for="(value, index) of news"
                    :key="index"
                    :item="value"
                />
            </section>

            <section v-if="tabs[$root.tabIndex] === '图集'" class="app-pics">
                <pics
                    :tab-changed="tabChanged"
                />
            </section>
        </template>
        <com-fold-cause
            :show-com-fold-cause="showComFoldCause"
            @closeComFoldPage="toggleComFoldPage"
        />
        <strategy-category-panel
            :visible.sync="showStrategyCatePanel"
            :game-name="appDetail.appName"
            :categories="appDetail.strategy_tag"
        />
        <section v-if="showBottomDownloadBtn || showJoinCommunityBtn">
            <!-- 手游下载按钮 -->
            <detail-download
                v-if="showDownloadBtn"
                :is-ios="!!isIOS"
                :official-joined="appDetail.officialJoined"
                :packages="appDetail.package_list"
                :app-detail="appDetail"
                :icon="appDetail.icon"
                :package-name="appDetail.package_name"
                :show-bottom-download-btn="showBottomDownloadBtn"
                :inter-btn-text="appDetail.book_button_text"
                :bussiness-info="appDetail.bussinessInfo"
                :download-url="appDetail.download_url"
                :app-id="appDetail.appId"
                :tieba-info="tiebaInfo"
                @openPanel="downloadPanelUnfolded = true"
                @passBtnTxt="passBtnTxt"
            />
            <!-- 端游下载按钮 -->
            <detail-download-pc
                v-if="showPcDownloadBtn"
                :packages="appDetail.pc_download_channel_packages"
                :is-free="appDetail.is_free"
                :is-sem="isSem"
                :jump-url="appDetail.jump_url"
                :low-price="appDetail.pc_channel_download_min_price.toString()"
                :official-joined="appDetail.officialJoined"
                :inter-btn-text="appDetail.book_button_text"
                :app-detail="appDetail"
                @openPanel="downloadPanelUnfolded = true"
                @passBtnTxt="passBtnTxt"
            />
            <!-- 预约按钮 -->
            <detail-appointment
                v-if="isAppointmentStatus && !isShowProductDetail"
                :official-joined="appDetail.officialJoined"
                :time="appDetail.predict_online_time"
                :btn-text="appointmentBtnText"
                :app-detail="appDetail"
                @appoinmentBtnClick="appoinmentBtnClick"
            />
            <!-- 电商购买按钮 -->
            <detail-buy
                v-if="isShowProductDetail"
                :btn-text="btnText"
                :buy-color="$root.officialHighLightBtnColor"
                :is-login="userInfo.is_login"
                :buy-already-text="buyAlreadyText"
                :sku-id="appDetail.goods_info.sku_id"
                :sem-url="appDetail.goods_info.url"
                :is-lowest="appDetail.goods_info.is_lowest_price"
                :real-price="appDetail.goods_info.real_price"
                :price-trend-text="priceTrendText"
                :app-detail="appDetail"
                @openPanel="purchasePanelUnfolded = true"
            />
            <detail-download-shop
                v-if="showShopDownload"
                :app-detail="appDetail"
                :tieba-info="tiebaInfo"
                :package-name="appDetail.package_name"
                :app-id="appDetail.appId"
                :packages="appDetail.package_list"
            />
            <recommend-download-drawer
                v-if="appDetail.recommend_download"
                :game-name="appDetail.appName"
                :game-icon="appDetail.icon"
                :game-capacity="appDetail.capacity"
                :tieba-info="tiebaInfo"
                :rc-drawer-info="appDetail.recommend_download"
            />
        </section>
        <!-- 手游推荐渠道弹出浮层 -->
        <section class="popup">
            <detail-panel
                :title="panelTitle"
                :unfolded="downloadPanelUnfolded"
                :adv-game-info="adGameInfo"
                :tieba-pop-data="tiebaPopData"
                :is-show-official-channel="isShowGameChannel"
                :app-name="appDetail.appName"
                :packages="isMobile ? appDetail.package_list || [] : appDetail.pc_download_channel_packages || []"
                @close="downloadPanelUnfolded = false"
            />
            <detail-panel
                :unfolded="appointmentPanelUnfolded"
                :packages="packageListAppointment"
                :title="panelTitle"
                type="appointment"
                @close="appointmentPanelUnfolded = false"
            />
        </section>
        <!-- 电商底部弹层 -->
        <section v-if="!!appDetail.goods_info">
            <purchase-panel
                :unfolded="purchasePanelUnfolded"
                :app-id="appDetail.appId"
                :app-name="appDetail.appName"
                :app-type="appDetail.appType"
                :is-login="userInfo.is_login"
                :buy-already-text="buyAlreadyText"
                :tieba-vip-status="appDetail.goods_info.tieba_vip_status"
                @close="purchasePanelUnfolded = false"
            />
        </section>
        <!-- 贴吧vip引导弹层 -->
        <section v-if="$root.isShowVipPanel">
            <vip-panel
                :vip-panel-info="appDetail.goods_info.vip_price_info"
                :tieba-vip-voucher-info="appDetail.goods_info.tieba_vip_voucher_info "
                :month-discount-sum="appDetail.goods_info.month_discount_sum"
                :app-id="appDetail.appId"
                :app-name="appDetail.appName"
                :app-type="appDetail.appType"
                :is-login="userInfo.is_login"
                :buy-already-text="buyAlreadyText"
            />
        </section>
        <!-- 预约弹框 -->
        <section v-if="showAppPopup">
            <appointment-popup
                @checkPopupStatus="showAppPopup = false"
                @bookSuccess="bookSuccess"
            />
        </section>

        <section v-if="showSuccessCard">
            <appointment-success-card
                :url="appDetail.jump_third_activity.jump_third_activity_url"
                @closeSuccessCard="closeSuccessCard"
            />
        </section>

        <section
            v-if="!$root.isFromTiebaFeed && $root.isShowTbFloatPanel && !tiebaInfo.is_show_ad"
            :class="['tieba-float-panel-wrap', showBottomDownloadBtn ? 'up' : 'down']"
        >
            <tieba-float-panel
                :tieba-info="tiebaInfo"
                :app-detail="appDetail"
            />
        </section>
        <section
            v-if="!$root.isFromTiebaFeed && tiebaInfo.is_show_ad"
            class="adv-float-panel-wrap"
        >
            <adv-float-panel
                :adv-info="tiebaInfo.layer_ad_info"
            />
        </section>
    </div>
</template>

<script>
import api from '@/api';
import {on, off, isScrollToEnd} from '@/utils/dom';
import {throttle, debounce} from 'throttle-debounce';
import {getQueryString, getUrlParams} from '@/utils/url';
import {handleJumpToMidPage} from '@/utils/login';
import {getDeepValue, openPage} from '@/utils/utility';
import Tab from './components/app-tabs';
import Detail from './components/app-detail';
import ComFoldCause from './components/com-fold-cause';
import {performanceMonitor, downloadApk, isIOS, browserDetect} from '@/utils/browser';
import StrategyCategoryPanel from '@/composition-components/zone/StrategyCategoryPanel.vue';
import DetailDownload from './components/detail/app-detail-download.vue';
import DetailPanel from './components/detail/app-detail-panel.vue';
import DetailDownloadPc from './components/detail/app-detail-download-pc';
import DetailDownloadShop from './components/detail/app-detail-download-shop.vue';
import DetailBuy from './components/detail/app-detail-buy.vue';
import PurchasePanel from './components/detail/app-detail-purchase-panel.vue';
import VipPanel from './components/detail/app-detail-vip-panel.vue';
import DetailAppointment from './components/detail/app-detail-appointment';
import AppointmentPopup from './components/detail/appointment-popup';
import AppointmentSuccessCard from './components/detail/appointment-success-card';
import TiebaFloatPanel from './components/tieba/tieba-float-panel.vue';
import AdvFloatPanel from './components/detail/app-detail-adv-float-panel.vue';
import RecommendDownloadDrawer from './components/detail/app-detail-download-recommend-drawer.vue';
import {isShowAppointmentBtn, appointmentBtnClick, appointmentBtnText} from '@/utils/comLogic/appointmentMethods';
import tbNAPI from '@baidu/tb-napi';
import backIconWhite from 'public/assets/imgs/zone-back-icon-white.png';
import backIconBlack from 'public/assets/imgs/zone-back-icon-black.png';
export default {
    components: {
        Tab,
        Detail,
        AppVideo: () => import(/* webpackChunkName: 'zone-async' */ './components/app-video'),
        Tieba: () => import(/* webpackChunkName: 'zone-async' */ './components/app-tieba'),
        Comment: () => import(/* webpackChunkName: 'zone-async' */ './components/app-comment'),
        Strategy: () => import(/* webpackChunkName: 'zone-async' */ './components/app-strategy'),
        NewsItem: () => import(/* webpackChunkName: 'zone-async' */ '@/components/zone/info-item'),
        Offical: () => import(/* webpackChunkName: 'zone-async' */ './components/app-offical.vue'),
        Answer: () => import(/* webpackChunkName: 'zone-async' */ './components/app-answer'),
        Pics: () => import(/* webpackChunkName: 'zone-async' */ './components/app-pics'),
        ComFoldCause,
        StrategyCategoryPanel,
        DetailDownload,
        DetailPanel,
        DetailDownloadPc,
        DetailDownloadShop,
        DetailBuy,
        PurchasePanel,
        VipPanel,
        DetailAppointment,
        AppointmentPopup,
        AppointmentSuccessCard,
        TiebaFloatPanel,
        RecommendDownloadDrawer,
        AdvFloatPanel,
    },
    data() {
        return {
            loading: false,
            appDetail: {},
            appComment: {},
            appVideo: {},
            appTieba: {},
            tabs: ['详情', '评价'],
            news: [],
            myFun: null,
            scrollToEnd: false,
            hasMoreData: true,
            params_news: '',
            cuid: '7ECBD60E0550D0ABA0D9E1AE8760811E35660446AOMFPNTFRPM',
            isSem: 0,
            showComFoldCause: false, // 是否展示评论折叠原因页
            loadMoreComponents: false, // 滚动页面加载更多异步组件
            scoreData: {}, // 游戏评分数据
            userInfo: { // 存放登录态和头像url的对象
                is_login: false,
                avatar: '',
            },
            isForceShopShow: 0, // 强制展示商品信息，1强制展示
            titleType: '',
            isAppointmentStatus: false,
            packageListAppointment: [],
            showStrategyCatePanel: false,
            tabChanged: false,
            isIOS: isIOS(),
            gameStatus: 0, // 0是默认无任何状态 1是预约 2是下载 3是已预约
            isMobile: true,
            panelTitle: '',
            showAppPopup: false,
            showSuccessCard: false,
            // 弹层折叠
            purchasePanelUnfolded: false,
            // 电商底部按钮文案
            appointmentBtnText: '',
            isShowProductDetail: false,
            btnText: '',
            buyAlreadyText: '',
            priceTrendData: {},
            priceTrendText: '',
            downloadPanelUnfolded: false,
            appointmentPanelUnfolded: false,
            isNewCard: false, // 是否为实验卡51261
            showJoinCommunityBtn: false,
            tiebaInfo: {},
            inBdBoxapp: false, // 是否在端内
            backIconWhite: backIconWhite,
            backIconBlack: backIconBlack,
            adGameInfo: {},
            tiebaPopData: {},
            isShowGameChannel: false,
        };
    },
    watch: {
        gameStatus(val) {
            if (val === 3) {
                this.appointmentBtnText = '已预约';
            }
            else if (val === 1) {
                const apiText = getDeepValue(this.appDetail, 'book_button_text.book_data');
                const {
                    officialJoined,
                    oldId,
                } = this.appDetail;
                this.appointmentBtnText = appointmentBtnText({
                    apiText,
                    officialJoined,
                    oldId,
                });
            }
        },
    },
    computed: {
        showBottomDownloadBtn() {
            const {tabIndex, isShowTopBtn} = this.$root;
            if (tabIndex === 0 && isShowTopBtn) {
                return false;
            }
            return this.isNewCard || this.appDetail.is_show_button_all_tab || tabIndex === 0;
        },
        showShopDownload() {
            if (this.appDetail.third_app_store_name) {
                if (this.inBdBoxapp && this.appDetail.is_show_app_store_layer) {
                    return true;
                }
                else if (!this.inBdBoxapp && this.appDetail.is_show_app_store_layer_out) {
                    return true;
                }
            }
            return false;
        },
        backIcon() {
            if (this.$root.officialHighLightBtnColor) {
                return backIconWhite;
            }
            return backIconBlack;

        },
        showDownloadBtn() {
            return (this.isMobile && this.appDetail.package_list?.length > 0)
                || this.appDetail.bussinessInfo?.appRcv || this.showJoinCommunityBtn;
        },
        showPcDownloadBtn() {
            return (!this.isMobile
                && this.appDetail.pc_download_channel_packages?.length)
                || this.appDetail.jump_url;
        },
    },
    async created() {
        this.purchasePanelUnfolded = Boolean(+getQueryString('purchasePanelUnfolded'));
        this.loading = true;
        this.$root.isTiebaApp = tbNAPI.env.isTBAPP;
        this.isSem = Number(getQueryString('from') === 'sem');
        // 方便查看数据,直接在链接上添加字段，强制展示商品信息
        this.isForceShopShow = Number(getQueryString('isForceShopShow'));
        // 判断是否从前卡进
        let srcid = 0;
        if (getQueryString('srcid') && this.isSem !== 1) {
            srcid = 1;
        }
        const {appId, type} = getUrlParams();
        let dParams = {
            data: {
                app_id: appId,
                is_front: srcid,
                sid: getQueryString('sid'),
                is_sem: this.isSem,
                is_force_shop_show: this.isForceShopShow,
                channel: getQueryString('channelid') || getQueryString('idfrom'),
                page_name: 'newDetailPageH5', // app导流区分页面来源使用，对前端透明
                is_business: getQueryString('isFcAdv') === '1' ? 1 : 0, // 是否是商业游戏
                src_id: getQueryString('srcid'),
                is_h5: true,
                tid: getQueryString('tid'),
            },
        };
        let p1 = api.zone.getGameDetail(dParams).catch(e => {
            console.log(e);
        });
        let p2 = api.zone.scoreData({
            data: {
                resource_id: appId,
                source: 1,
            },
        }).catch(e => {
            console.log(e);
        });
        let p3 = api.zone.getUserInfo().catch(e => {
            console.log(e);
        });
        let [appDetail, scoreData, userInfo] = await Promise.all([p1, p2, p3]);
        userInfo && (this.userInfo = userInfo);
        scoreData && (this.scoreData = scoreData);
        let answersTabHas = false;
        let dynamicTabHas = false;
        if (appDetail && appDetail.modules) {
            appDetail.modules.map(item => {
                switch (item.type) {
                    case 'officialNewsPostTimeAxis':
                        dynamicTabHas = true;
                        break;
                    case 'answers':
                        answersTabHas = true;
                        break;
                    case 'video':
                        this.tabs.push('视频');
                        break;
                    case 'tieBa':
                        this.tabs.push('贴吧');
                        break;
                    case 'article':
                        this.tabs.push('资讯');
                        break;
                    case 'strategy':
                    case 'thirdStrategy':
                        this.tabs.push('攻略');
                        break;
                    case 'pics':
                        this.tabs.push('图集');
                        break;
                }
            });
        }
        this.$root.isPreDownload = getDeepValue(appDetail, 'is_pre_download');
        this.$root.isSuperProduct = getDeepValue(appDetail, 'is_super_product');
        if (dynamicTabHas) {
            this.tabs.splice(1, 0, '动态');
        }
        let tabsArr = this.tabs;
        if (answersTabHas) {
            this.initTabs(tabsArr);
        }
        this.$root.tabs = this.tabs;
        this.$root.tabs.map(e => {
            this.$logger.show({
                value: e,
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign(this.$root.extData),
                            pos: '',
                            sid: getQueryString('sid') || '',
                            srcId: getQueryString('srcid') || '',
                            channelid: getQueryString('channelid') || '',
                        },
                    ],
                },
            });
        });
        this.appDetail = appDetail || {};
        this.loading = false;
        if (this.appDetail.appType !== 11 && this.appDetail.appType !== 16) {
            this.isMobile = false;
        }
        this.adGameInfo = this.appDetail?.pop_info?.ad_game_info;
        this.tiebaPopData = this.appDetail?.pop_info?.tieba_pop_data;
        this.isShowGameChannel = this.appDetail?.pop_info?.is_show_game_channel;
        this.packageType = this.appDetail?.package_list?.[0]?.package_type;
        this.$nextTick(() => {
            // 发送到达
            if (!window.isSendWiseEndCount) {
                performanceMonitor('13_96', 'gamepage_zone');
                window.isSendWiseEndCount = true;
            }
            const businessUrl = getQueryString('fc_package_url');
            if (businessUrl && getQueryString('isDownload') === '2') {
                downloadApk(businessUrl);
            }
        });
        this.processOfficialStyle(appDetail);
        const {browserVersion, browserName} = window.detailUserAgentInfo;
        let gameType = getDeepValue(appDetail, 'appType');
        if (gameType && gameType === 11) {
            gameType = !appDetail.oldId || appDetail.oldId === '0' ? 8 : 11;
        }
        this.$root.extData = {
            gameId: appDetail.appId,
            gameType,
            gameType2: decodeURI(type) || '',
            gameName: appDetail.appName,
            status: appDetail.subscribe_or_download || 2,
            browserVersion,
            browserName,
            isOfficial: this.appDetail.officialJoined,
            subscribe_or_download: this.appDetail.subscribe_or_download,
            sid: getQueryString('sid') || '',
            srcId: getQueryString('srcid') || '',
            channelid: getQueryString('channelid') || '',
        };
        let cuid = this.cuid;
        const commentParams = {
            data: {
                resource_id: appId,
                order: 0,
                type: 0,
                pNum: 1,
                pSize: 10,
                is_sem: this.isSem,
                cuid,
            },
        };

        const tParams = {
            data: {
                app_id: appId,
                kw: appDetail.appName,
                appType: appDetail.appType,
                pn: 1,
                rn: 10,
                tab_id: 1,
                sort_type: 0,
                type: 1,
                call_from: 'game',
                is_front: srcid,
            },
        };

        api.zone.getGameComment(commentParams).then(appComment => {
            this.appComment = appComment;
        });
        api.zone.getGameTieba(tParams).then(appTieba => {

            this.appTieba = appTieba.data;
        });


        if (this.tabs.includes('攻略')) {
            // TODO: check is need and delete
            // console.log('appDetail', this.appDetail);
        }
        this.params_news = {
            data: {
                app_id: appId,
                type: 2,
                pnum: 1,
                psize: 10,
            },
        };
        if (this.tabs.includes('资讯')) {
            api.zone.getNewsInfo(this.params_news).then(news => {
                this.news = news.list;
            });
        }
        let anchorPoint = this.getAnchorPointFromUrl(window.location.href);
        if (anchorPoint && anchorPoint.startsWith('_wiki-')) { // 百科特殊的锚点逻辑
            const current = parseInt(anchorPoint.split('-')[1], 10) || 0;
            this.$root.bkAnchor = current;
        }
        else {
            switch (anchorPoint) {
                case 'news':
                    this.$root.tabIndex = this.findTabIndex('资讯');
                    break;
                case 'strategy':
                    this.$root.tabIndex = this.findTabIndex('攻略');
                    break;
                case 'video':
                    this.$root.tabIndex = this.findTabIndex('视频');
                    break;
                case 'commentTab':
                    this.$root.tabIndex = this.findTabIndex('评价');
                    break;
                case 'pics':
                    this.$root.tabIndex = this.findTabIndex('图集');
                    break;
            }
        }

        this.myFun = throttle(500, this.loadMoreData);
        this.showDisplayLogFun = debounce(500, () => {
            this.doDisplayLog();
        });
        on(window, 'scroll', () => {
            this.myFun();
            this.showDisplayLogFun();
            if (!this.loadMoreComponents && window.scrollY > 50) {
                this.loadMoreComponents = true;
            }
        });
        this.doShowLog();
        if (getQueryString('srcid') === '51261') {
            this.isNewCard = true;
        }
        if (this.appDetail.goods_info) {
            this.isShowProductDetail = true;
        }
        if (this.appDetail.join_community_info) {
            this.showJoinCommunityBtn = true;
        }

        // 预约相关逻辑
        const {
            appType,
            oldId,
            subscribe_or_download,
            pc_subscribe_channel_packages,
            mobile_subscribe_package_list,
            officialJoined,
        } = this.appDetail;
        const obj = {
            needInternalAppoinment: !this.isSem,
            appType,
            officialJoined,
            oldId,
            status: subscribe_or_download,
            pc_channels: pc_subscribe_channel_packages,
            mobile_channels: mobile_subscribe_package_list,
        };
        // 获取是否需要展示预约按钮
        const {
            isShow,
        } = isShowAppointmentBtn(obj);
        if (isShow) {
            this.gameStatus = 1;
            this.isAppointmentStatus = true;
        }
        this.btnText = getDeepValue(this.appDetail, 'book_button_text.buy_data')
            || getDeepValue(this.appDetail.goods_info, 'btn_text');
        this.buyAlreadyText = getDeepValue(this.appDetail.goods_info, 'buy_already_text');
        // 获取贴吧导流浮层相关数据
        const tbParams = {
            data: {
                app_id: appId,
                app_name: appDetail.appName,
                app_type: appDetail.appType,
                is_shop: appDetail.is_shop,
                is_h5: true,
                src_id: getQueryString('srcid'),
                package_type: appDetail?.package_list?.[0]?.package_type,

            },
        };
        await api.zone.getTbFloatPanelInfo(tbParams).then(data => {
            if (Object.keys(data).length > 0) {
                this.tiebaInfo = data;
            }
            else {
                this.$root.isShowTbFloatPanel = false;
            }
        });
        this.inBdBoxapp = browserDetect('bdbox');

        const isWakeAppStore = getQueryString('isWakeAppStore');
        if (isWakeAppStore === '1' && this.isIOS) {
            const {IOS_DOWNLOAD} = this.$root.DOWNLOAD_ACTIONS;
            const {action, jump_url} = this.appDetail.package_list[0];
            const urlReg = new RegExp(/^(https:\/\/apps.apple.com\/)|(https:\/\/itunes.apple.com\/)/);
            if (IOS_DOWNLOAD === action && jump_url && jump_url.match(urlReg)) {
                location.href = jump_url;
            }
        }
    },
    mounted() {
        let alter = getQueryString('alter');
        if (alter === '1') {
            if (!this.isMobile
                && this.appDetail.pc_download_channel_packages
                && this.appDetail.pc_download_channel_packages.length) {
                this.downloadPanelUnfolded = true;
            }
        }
    },
    destroyed() {
        off(window, 'scroll', () => {
            this.myFun();
            this.showDisplayLogFun();
        });
    },
    methods: {
        // 用户点击登录
        loginClick() {
            handleJumpToMidPage(window.location.href);
        },
        initTabs(tabsArr) {
            let isTab = getQueryString('tab') === 'answer';
            let index = tabsArr.indexOf('评价');
            if (index > -1) {
                this.tabs.splice(index + 1, 0, '问答');
                this.$root.tabIndex = isTab ? index + 1 : this.$root.tabIndex;
                return;
            }
            let index1 = tabsArr.indexOf('视频');
            if (index1 > -1) {
                this.tabs.splice(index1 - 1, 0, '问答');
                this.$root.tabIndex = isTab ? index1 - 1 : this.$root.tabIndex;
                return;
            }
            let index2 = tabsArr.indexOf('动态');
            if (index2 > -1) {
                this.tabs.splice(index2 + 1, 0, '问答');
                this.$root.tabIndex = isTab ? index2 + 1 : this.$root.tabIndex;
                return;
            }
            let index3 = tabsArr.indexOf('详情');
            if (index3 > -1) {
                this.tabs.splice(index3 + 1, 0, '问答');
                this.$root.tabIndex = isTab ? index3 + 1 : this.$root.tabIndex;
                return;
            }
        },
        passBtnTxt(val) {
            this.panelTitle = val;
        },
        appoinmentBtnClick() {
            if (this.gameStatus === 1) { // 判断状态为未预约
                const {
                    appType,
                    pc_subscribe_channel_packages,
                    mobile_subscribe_package_list,
                } = this.appDetail;
                const packageListAppointment = appointmentBtnClick({
                    appType,
                    pc_channels: pc_subscribe_channel_packages,
                    mobile_channels: mobile_subscribe_package_list,
                });
                if (packageListAppointment && packageListAppointment.length === 1) {
                    window.location = packageListAppointment[0].jump_url;
                    return;
                }
                else if (packageListAppointment && packageListAppointment.length > 1) {
                    this.packageListAppointment = packageListAppointment;
                    this.appointmentPanelUnfolded = true;
                    return;
                }
                // 如果不是超品期间且不是来自品专那么需要做兜底
                if (!this.isSem) {
                    this.showAppPopup = this.appDetail.officialJoined || +this.appDetail.oldId;
                }
            }
        },
        getAnchorPointFromUrl(url = '') {
            if (!url) {
                return {};
            }
            const arr = /\?(.*)/.exec(url);
            if (!arr || arr.length < 1) {
                return {};
            }
            let anchorPoint = '';
            const queryStr = arr[1];
            queryStr.split('#').forEach(query => {
                anchorPoint = query;
            });
            return anchorPoint;
        },
        loadMoreData() {
            if (this.tabs[this.$root.tabIndex] !== '资讯'
                || (!isScrollToEnd() || !this.hasMoreData || this.scrollToEnd)) {
                return;
            }
            this.scrollToEnd = true;
            this.fetchNewsData().then(res => {
                if (res.list && res.list.length > 0) {
                    this.news = this.news.concat(res.list);
                }
                else {
                    this.hasMoreData = false;
                }
                this.scrollToEnd = false;
            }).catch(() => {
                this.hasMoreData = false;
            });
        },
        fetchNewsData() {
            this.params_news.data.pnum++;
            return api.zone.getNewsInfo(this.params_news);
        },
        processOfficialStyle() {
            try {
                const {
                    officialJoined,
                    official_big_img: officialBigImg,
                    official_big_img_color: colors,
                } = this.appDetail || {};
                this.$root.officialBigImg = officialBigImg?.url;
                Object.keys(colors).forEach(key => {
                    colors[key] = colors[key] ? `#${colors[key]}` : '';
                });
                // 官方入驻样式及颜色选取
                this.$root.officialJoinedStyle = !!(officialJoined && officialBigImg && colors?.background);
                this.$root.officialJoinedColors = colors;
            }
            catch (e) {
                console.log(e);
            }
        },
        doShowLog() {
            function genWord(flag) {
                return flag ? 'yes' : 'no';
            }
            const titleList = getDeepValue(this.appDetail, 'title_list') || [];
            const hasWiki = titleList.length > 0;
            // 需要兼容旧样式及新样式的动态
            const dynamic = this.appDetail.modules.filter(item => {
                return (item.moduleId === 13 || item.moduleId === 18);
            })[0];
            const hasStrategy = !!getDeepValue(this.appDetail, 'strategy_tag.length')
                || !!getDeepValue(this.appDetail, 'strategy_list.length');
            this.$logger.show({
                value: '',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign(this.$root.extData, {
                                official: genWord(getDeepValue(this.appDetail, 'officialJoined')),
                                strongStyle: genWord(this.$root.officialJoinedStyle),
                                baike: genWord(hasWiki),
                                dynamic: genWord(!!dynamic),
                                hasStrategy: genWord(hasStrategy),
                                isOriginPc: genWord(getQueryString('isOriginPc')),
                            }),
                            pos: '',
                        },
                    ],
                },
            });
        },
        toggleComFoldPage() {
            this.showComFoldCause = !this.showComFoldCause;
        },
        doDisplayLog() {
            this.$logger.inScreen('.pb-show-display', dataset => {
                this.$logger.display(dataset);
            });
            this.$logger.inScreen('.pb-show-showVideos', dataset => {
                this.$logger.showVideos(dataset);
            });

        },
        bookSuccess() {
            this.gameStatus = 3;
            this.showAppPopup = false;
        },
        closeSuccessCard() {
            this.showSuccessCard = false;
        },
        givepriceTrendData(priceTrendData, priceTrendText) {
            this.priceTrendData = priceTrendData;
            this.priceTrendText = priceTrendText;
            this.priceTrendText = priceTrendData.price_list[0].price_trend_text;
        },
        onTabChange() {
            this.tabChanged = true;
            this.doDisplayLog();
        },
        findTabIndex(tabName) {
            const index = this.tabs.findIndex(item => item === tabName);
            if (index === -1) {
                this.sendMyError('zoneTabGap', {
                    msg: `专区页${tabName}tab缺失`,
                });
            }
            return index > 0 ? index : 0;
        },
        goBackClick() {
            history.back();
        },
        toOrderPage() {
            openPage('orderList', getUrlParams());
        },
    },
};

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";

    $design-width: 1242;

    html {
        @include root-font-size();
    }

    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
    }
    body {
        padding-top: px2rem(252);
    }
    .scroll-x {
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: scroll;
        overflow-y: hidden;
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
    }
    .clamp-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }
    .clamp-content-5 {
        -webkit-line-clamp: 5;
    }
    .clamp-content-3 {
        -webkit-line-clamp: 3;
    }
    .clamp-content-2 {
        -webkit-line-clamp: 2;
    }
    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .title {
            width: px2rem(600);
            text-align: center;
            font-size: px2rem(54);
            // color: #1F1F1F;
            font-weight: bold;
            height: px2rem(132);
            line-height: px2rem(132);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .back-icon {
            width: 62px;
            height: 62px;
            margin-left: 51px;
        }
        .not-login {
            font-size: px2rem(42);
            letter-spacing: 0;
            font-weight: 400;
            margin-right: px2rem(51);
            line-height: px2rem(132);
        }
        .is-login{
            width: px2rem(80);
            height: px2rem(80);
            border-radius: 50%;
            margin: px2rem(26) px2rem(51);
        }
    }
    .arrow-right {
        width: px2rem(25);
        height: px2rem(40);
    }
    .app-zone-container {
        padding-bottom: constant(safe-area-inset-bottom);  //兼容ios<11.2
        padding-bottom: env(safe-area-inset-bottom);  //兼容ios>=11.2
        .page-head{
            position: fixed;
            top: 0;
            width: px2rem(1242);
            background-color: #fff;
            z-index: 999;
        }
        .news-wrapper{
            padding: px2rem(52) px2rem(51) 0 px2rem(51);
            .news-item-content{
                padding-bottom: 15px;
                margin-bottom: 16px;
                border-bottom: 1px solid #eeeeee;
            }
        }
        .app-pics {
            padding: px2rem(51);
        }
    }
    .tieba-float-panel-wrap {
        position: fixed;
        left: calc(50% - 570px);
        background: #FFFFFF;
        box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.1);
        border-radius: 36px;
        &.up {
            bottom: 237px;
        }
        &.down {
            bottom: 237px;
        }
    }
    .adv-float-panel-wrap {
        position: fixed;
        bottom: 237px;
        left: calc(50% - 570px);
    }
</style>